import { graphql } from 'gatsby';
import React from 'react';
import { Accordion as AccordionComponent } from '../../../accordion/Accordion';

export const Accordion = ({ data, ...rest }) => (
  <AccordionComponent {...data} {...rest} />
);

export const AccordionQuery = graphql`
  fragment Accordion on UMBRACO_AccordionComponentType {
    addFaqschema
    items {
      title
      content
    }
  }
`;
